const DEFAULT_SAMPLES = 32;

function cubicPoint(points, t) {
  const [p0, p1, p2, p3] = points;
  const mt = 1 - t;

  return {
    x:
      mt ** 3 * p0.x +
      3 * mt ** 2 * t * p1.x +
      3 * mt * t ** 2 * p2.x +
      t ** 3 * p3.x,
    y:
      mt ** 3 * p0.y +
      3 * mt ** 2 * t * p1.y +
      3 * mt * t ** 2 * p2.y +
      t ** 3 * p3.y,
  };
}

function cubicDerivative(points, t) {
  const [p0, p1, p2, p3] = points;
  const mt = 1 - t;

  return {
    x:
      3 * mt ** 2 * (p1.x - p0.x) +
      6 * mt * t * (p2.x - p1.x) +
      3 * t ** 2 * (p3.x - p2.x),
    y:
      3 * mt ** 2 * (p1.y - p0.y) +
      6 * mt * t * (p2.y - p1.y) +
      3 * t ** 2 * (p3.y - p2.y),
  };
}

function distance(a, b) {
  return Math.hypot(b.x - a.x, b.y - a.y);
}

function findArcMidpointT(points, samples = DEFAULT_SAMPLES) {
  const segments = [];
  let previous = cubicPoint(points, 0);
  let totalLength = 0;

  for (let index = 1; index <= samples; index += 1) {
    const t = index / samples;
    const point = cubicPoint(points, t);
    const segmentLength = distance(previous, point);
    segments.push({
      startT: (index - 1) / samples,
      endT: t,
      startLength: totalLength,
      segmentLength,
    });
    totalLength += segmentLength;
    previous = point;
  }

  if (!totalLength) return 0.5;

  const targetLength = totalLength / 2;
  const segment =
    segments.find(
      (candidate) =>
        candidate.startLength + candidate.segmentLength >= targetLength
    ) || segments[segments.length - 1];
  const progress = segment.segmentLength
    ? (targetLength - segment.startLength) / segment.segmentLength
    : 0;

  return segment.startT + (segment.endT - segment.startT) * progress;
}

function makeAngleReadable(derivative) {
  let x = derivative.x;
  let y = derivative.y;
  let angle = (Math.atan2(y, x) * 180) / Math.PI;

  if (angle > 90 || angle < -90) {
    x *= -1;
    y *= -1;
    angle += angle > 90 ? -180 : 180;
  }

  return { x, y, angle };
}

export function getBezierLabelGeometryAtT(points, t, offset = 7) {
  const point = cubicPoint(points, t);
  const readableTangent = makeAngleReadable(cubicDerivative(points, t));
  const tangentLength =
    Math.hypot(readableTangent.x, readableTangent.y) || 1;
  const normal = {
    x: -readableTangent.y / tangentLength,
    y: readableTangent.x / tangentLength,
  };

  return {
    x: point.x - normal.x * offset,
    y: point.y - normal.y * offset,
    angle: readableTangent.angle,
  };
}

export function getBezierLabelGeometry(points, offset = 7) {
  return getBezierLabelGeometryAtT(points, findArcMidpointT(points), offset);
}
